module.exports = __webpack_public_path__ + "static/img/minus.4d393917.svg";